import { FileText, ShieldCheck } from "lucide-react";
import { AccountShell } from "@/components/AccountShell";
import { useLang } from "@/context/LanguageContext";
import LEGAL from "@/lib/legalTexts.json";

// Same text + markup as the app (src/legalTerms.ts): "## " heading, "### " sub-heading, "- " bullet, "Label: text" paragraph.
function Para({ p, i }) {
  if (p.startsWith("## ")) return <h2 key={i} className="font-headline text-lg font-extrabold text-[#1A5C3A] mt-6 mb-2">{p.slice(3)}</h2>;
  if (p.startsWith("### ")) return <h3 key={i} className="font-bold text-slate-900 mt-4 mb-1">{p.slice(4)}</h3>;
  if (p.startsWith("- ")) return <p key={i} className="flex gap-2 text-[15px] text-slate-700 leading-relaxed mb-1.5"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#1A5C3A] shrink-0" />{p.slice(2)}</p>;
  const idx = p.indexOf(":");
  const head = idx > 0 && idx < 40 ? p.slice(0, idx) : null;
  return <p key={i} className="text-[15px] text-slate-700 leading-relaxed mb-2">{head ? <><b className="text-slate-900">{head}:</b> {p.slice(idx + 1).trim()}</> : p}</p>;
}

export default function LegalDoc({ kind }) {
  const { lang } = useLang();
  const L = (ar, en) => (lang === "en" ? en : ar);
  const privacy = kind === "privacy";
  const body = LEGAL[`${privacy ? "PRIVACY" : "TERMS"}_${lang === "en" ? "EN" : "AR"}`] || "";
  const Icon = privacy ? ShieldCheck : FileText;
  return (
    <AccountShell title={privacy ? L("سياسة الخصوصية", "Privacy policy") : L("الشروط والأحكام", "Terms & conditions")} testid={`legal-${kind}`}>
      <div className="rounded-2xl border border-[#EFEBE0] bg-white p-5 mb-4 flex items-center gap-3">
        <span className="w-12 h-12 rounded-full bg-[#E8EFEA] flex items-center justify-center"><Icon className="w-6 h-6 text-[#1A5C3A]" /></span>
        <div><p className="font-extrabold">Bazaroo</p><p className="text-xs text-slate-500" data-testid="legal-updated">{L("آخر تحديث", "Last updated")}: {LEGAL.LAST}</p></div>
      </div>
      <article className="rounded-2xl border border-[#EFEBE0] bg-white p-5" data-testid="legal-body">
        {body.split("\n").filter((p) => p.trim()).map((p, i) => <Para key={i} p={p} i={i} />)}
      </article>
    </AccountShell>
  );
}
